module.exports = __webpack_public_path__ + "static/media/42.f38d0ea4.jpg";